import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '../../../../shared/translate.service';
import {UserQueryDto, UserQueryDtoInterface} from '../dto/user-query-dto';

@Component({
  selector: 'app-user-query',
  templateUrl: './user-query.component.html',
  styleUrls: ['./user-query.component.scss']
})
export class UserQueryComponent implements OnInit {

  userQueryDto: UserQueryDtoInterface;
  public creation: boolean;

  constructor(public activeModal: NgbActiveModal, private translator: TranslateService) {
  }

  ngOnInit() {
    this.creation = !this.userQueryDto;
    if (!this.userQueryDto) {
      this.userQueryDto = UserQueryDto.create();
    } else {
      this.rewriteInstance();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  modalLabel() {
    if (this.creation) {
      return this.translator.translate('UserQuery.creation');
    } else {
      return this.translator.translate('UserQuery.edit') + ' ' + this.userQueryDto.title;
    }
  }

  onSubmit() {
    this.userQueryDto.notification = true;
    this.activeModal.close(this.userQueryDto);
  }

  private rewriteInstance() {
    const emptyQueryDto = UserQueryDto.create();
    emptyQueryDto.id = this.userQueryDto.id;
    emptyQueryDto.itemsCount = this.userQueryDto.itemsCount;
    emptyQueryDto.newItemsCount = this.userQueryDto.newItemsCount;
    emptyQueryDto.title = this.userQueryDto.title;
    emptyQueryDto.note = this.userQueryDto.note;
    emptyQueryDto.notification = this.userQueryDto.notification;
    emptyQueryDto.searchQuery = this.userQueryDto.searchQuery;
    emptyQueryDto.visitTime = this.userQueryDto.visitTime;
    emptyQueryDto.updateTime = this.userQueryDto.updateTime;
    emptyQueryDto.previousUpdateTime = this.userQueryDto.previousUpdateTime;
    this.userQueryDto = emptyQueryDto;
  }
}
